import { render, staticRenderFns } from "./OnboardingContent.vue?vue&type=template&id=46e4803c&scoped=true"
import script from "./OnboardingContent.vue?vue&type=script&lang=js"
export * from "./OnboardingContent.vue?vue&type=script&lang=js"
import style0 from "./OnboardingContent.vue?vue&type=style&index=0&id=46e4803c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e4803c",
  null
  
)

export default component.exports